var map = {
	"./Language.svg": 51071,
	"./Menu - English.svg": 54977,
	"./Menu - Sinhala.svg": 51522,
	"./Menu.svg": 35276,
	"./Queue.svg": 25393,
	"./Voicemail.svg": 4164,
	"./Welcome.svg": 83340,
	"./ards.svg": 91645,
	"./call.svg": 25802,
	"./default.svg": 56959,
	"./dial.svg": 0,
	"./end.svg": 63314,
	"./logout.svg": 27624,
	"./notification.svg": 72048,
	"./pause.svg": 45350,
	"./play.svg": 97752,
	"./play_and_detect_speech.svg": 17810,
	"./play_and_get_digit.svg": 47860,
	"./play_and_get_digits.svg": 73961,
	"./playback.svg": 57627,
	"./record.svg": 47100,
	"./say.svg": 76326,
	"./speak.svg": 90055,
	"./start.svg": 39943,
	"./voicemail - 1.svg": 54504,
	"./workingHours.svg": 73017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20866;